const SYNC_DEVICE_MODE_KEY = "planificador_sync_device_mode";
const REG_ID_KEY = "planificador_offline_reg_id";

export function isTabletSyncMode() {
  return localStorage.getItem(SYNC_DEVICE_MODE_KEY) === "tablet";
}

export function setSyncDeviceMode(mode) {
  localStorage.setItem(SYNC_DEVICE_MODE_KEY, mode);
}

export function getRegId() {
  if (!isTabletSyncMode()) {
    return "0";
  }

  let regId = localStorage.getItem(REG_ID_KEY);

  if (!regId) {
    regId = crypto.randomUUID();
    localStorage.setItem(REG_ID_KEY, regId);
  }

  return regId;
}

export function getSyncMin(serviceMin) {
  if (!isTabletSyncMode()) {
    return 0;
  }

  return serviceMin ?? 0;
}
